import React, { useEffect, useState } from 'react';
import { canInstall, isIos, isStandalone, promptInstall, subscribeToInstall } from '../utils/pwaInstall';

// Bouton qui installe la PWA FSF, avec des instructions quand le navigateur ne permet pas l'installation directe
const InstallAppButton = ({ className = '', children = "📱 Télécharger l'App Mobile" }) => {
  const [, forceRender] = useState(0);
  const [hint, setHint] = useState('');

  useEffect(() => subscribeToInstall(() => forceRender((n) => n + 1)), []);

  if (isStandalone()) {
    return (
      <div className="w-full bg-green-50 border border-green-200 text-green-700 py-3 px-4 rounded-lg text-center text-sm">
        ✅ L'application FSF est déjà installée sur cet appareil.
      </div>
    );
  }

  const handleClick = async () => {
    setHint('');
    if (canInstall()) {
      const outcome = await promptInstall();
      if (outcome === 'accepted') {
        setHint("✅ Installation en cours. Retrouvez l'application FSF sur votre écran d'accueil.");
      }
      return;
    }
    setHint(
      isIos()
        ? "Sur iPhone/iPad : ouvrez ce site dans Safari, appuyez sur le bouton Partager puis sur « Sur l'écran d'accueil »."
        : "Ouvrez le menu de votre navigateur (⋮) puis choisissez « Installer l'application » ou « Ajouter à l'écran d'accueil »."
    );
  };

  return (
    <div className="w-full">
      <button type="button" onClick={handleClick} className={className}>
        {children}
      </button>
      {hint && <p className="mt-2 text-sm text-gray-600 text-left">{hint}</p>}
    </div>
  );
};

export default InstallAppButton;
